<template>
  <div>

    <!--to-top-->
    <div class="to-top"><img src="/static/img/to-top.png"/></div>
    <div class="pop-mask"></div>

    <div class="inner-banner join-banner pc-inner-banner"></div>
    <div class="mobile-inner-banner join-banner">
      <img src="/static/img/join-banner.jpg"/>
    </div>
    <div class="inner-main">
      <div class="wrap">
        <div class="join-apply">
          <h3 class="wow fadeInDown">申请加入我们的数据平台</h3>
          <p class="wow fadeInDown">请如实填写以下信息，我们将尽快与您联系</p>


          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="您的名字" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入您的名字"></el-input>
            </el-form-item>
            <el-form-item label="您的电话" prop="phone">
              <el-input v-model.number="ruleForm.phone" placeholder="请输入您的电话"></el-input>
            </el-form-item>
            <el-form-item label="您的邮箱" prop="email">
              <el-input v-model="ruleForm.email" placeholder="请输入您的邮箱"></el-input>
            </el-form-item>
            <el-form-item label="您的单位" prop="company">
              <el-input v-model="ruleForm.company" placeholder="请填写所属医院全称"></el-input>
            </el-form-item>

            <el-form-item label="单位所属省市" prop="province">
              <el-input v-model="ruleForm.province" placeholder="请填写所属省市"></el-input>
            </el-form-item>

            <el-form-item label="您的职称/职位" prop="title">
              <el-select v-model="ruleForm.title" placeholder="请选择您的职称">
                <el-option label="院长" value="院长"></el-option>
                <el-option label="副院长" value="副院长"></el-option>
                <el-option label="科室主任" value="科室主任"></el-option>
                <el-option label="主任医师" value="主任医师"></el-option>
                <el-option label="副主任医师" value="副主任医师"></el-option>
                <el-option label="主治医师" value="主治医师"></el-option>
                <el-option label="住院医师" value="住院医师"></el-option>
                <el-option label="研究生" value="研究生"></el-option>
                <el-option label="实习生" value="实习生"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="您想要了解的信息" prop="text">
              <el-input type="textarea" v-model="ruleForm.text" placeholder="请输入您想要了解的信息"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="down-list wow fadeInLeft">
          <div class="down-title">
            <div class="list-title item01">名称</div>
            <span class="line"></span>
            <div class="list-title item02">下载</div>
          </div>
          <ul>
            <li>
              <div class="list-tit style03 wow fadeInLeft">大中华减重与代谢手术数据库登代谢手术数据库登记章程（草案）V...</div>
              <span class="line"></span>
              <a target="_blank"
                 href="https://c-mbs.oss-cn-beijing.aliyuncs.com/joinus/%E5%A4%A7%E4%B8%AD%E5%8D%8E%E5%87%8F%E9%87%8D%E4%B8%8E%E4%BB%A3%E8%B0%A2%E6%89%8B%E6%9C%AF%E6%95%B0%E6%8D%AE%E5%BA%93%E7%99%BB%E4%BB%A3%E8%B0%A2%E6%89%8B%E6%9C%AF%E6%95%B0%E6%8D%AE%E5%BA%93%E7%99%BB%E8%AE%B0.pdf"
                 class="down-btn wow fadeInRight"></a>
            </li>
            <li>
              <div class="list-tit style03 wow fadeInLeft">大中华减重与代谢手术数据库管理办法</div>
              <span class="line"></span>
              <a target="_blank"
                 href="https://c-mbs.oss-cn-beijing.aliyuncs.com/joinus/%E5%A4%A7%E4%B8%AD%E5%8D%8E%E5%87%8F%E9%87%8D%E4%B8%8E%E4%BB%A3%E8%B0%A2%E6%89%8B%E6%9C%AF%E6%95%B0%E6%8D%AE%E5%BA%93%E7%AE%A1%E7%90%86%E5%8A%9E%E6%B3%95.pdf"
                 class="down-btn wow fadeInRight"></a>
            </li>
            <li>
              <div class="list-tit style03 wow fadeInLeft">大中华数据库SOP（1.3）.pdf</div>
              <span class="line"></span>
              <a target="_blank"
                 href="https://c-mbs.oss-cn-beijing.aliyuncs.com/joinus/%E5%A4%A7%E4%B8%AD%E5%8D%8E%E6%95%B0%E6%8D%AE%E5%BA%93SOP.pdf"
                 class="down-btn wow fadeInRight"></a>
            </li>
            <li>
              <div class="list-tit style02 wow fadeInLeft">大中华数据库受试者编号生成表.xlsx</div>
              <span class="line"></span>
              <a target="_blank"
                 href="https://c-mbs.oss-cn-beijing.aliyuncs.com/joinus/%E5%A4%A7%E4%B8%AD%E5%8D%8E%E6%95%B0%E6%8D%AE%E5%BA%93%E5%8F%97%E8%AF%95%E8%80%85%E7%BC%96%E5%8F%B7%E7%94%9F%E6%88%90%E8%A1%A8.xlsx"
                 class="down-btn wow fadeInRight"></a>
            </li>
            <li>
              <div class="list-tit style03 wow fadeInLeft">数据库随访录入说明.pdf</div>
              <span class="line"></span>
              <a target="_blank"
                 href="https://c-mbs.oss-cn-beijing.aliyuncs.com/joinus/c-mbs.pdf"
                 class="down-btn wow fadeInRight"></a>
            </li>
            

          </ul>
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="wrap">
        <a href="#" class="f-logo wow fadeInLeft"><img src="/static/img/f-logo.png"/></a>
        <!--			<p class="wow fadeInRight">地址：北京市海淀区善缘街1号3段</p>-->
        <p class="wow fadeInRight">Copyright © 2017-2020 大中华减重与代谢外科数据平台京ICP备17044059号 </p>
        <p>平台支持：<a target="_blank" href="http://www.edocdata.com/">北京易得医数科技有限责任公司</a></p></div>
    </footer>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import ApplicationData from '../components/applicationData'
import Api from '../api/index'
// import {email} from "../api/email/email";

export default {
  components: {ApplicationData},
  data() {
    const checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      if (!Number.isInteger(value)) {
        callback(new Error('请输入数字类型'));
      } else {
        if (value.toString().length === 11) {
          callback();
        } else {
          return callback(new Error('请输入11位手机号码'));
        }
      }
    }
    return {
      ruleForm: {
        name: '',
        phone: '',
        email: '',
        company: '',
        title: '',
        text: '',
        province: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入你的名字', trigger: 'blur'},
        ],
        phone: [
          {type: 'number', required: true, message: '请输入您的11位手机号', trigger: 'blur', validator: checkAge,},

        ],
        email: [
          {required: true, message: '请输入邮箱地址', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
        ],
        company: [
          {required: true, message: '请输入你的单位', trigger: 'change'}
        ],
        title: [
          {required: true, message: '请选择职称', trigger: 'change'}
        ],
        text: [
          {required: true, message: '请输入您想要了解的信息', trigger: 'blur'}
        ],
        province: [
          {required: true, message: '请输入所属省市', trigger: 'change'}
        ],
      }

    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate( (valid) => {
        if (valid) {
          console.log(this.ruleForm,Api);
          Api.postContact(this.ruleForm).then(result => {
           if(result.data.success){
             this.$message(result.data.message);
           }else{
             this.$message('发送失败，请稍后尝试');
           }
         })


        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
   mounted() {
    this.$nextTick(() => {
      var wow = new WOW({
        live: false
      })
      wow.init()

      lay('#version').html('-v' + laydate.v);
      //执行一个laydate实例
      laydate.render({
        elem: '#date-limit'
        , range: true
      });
    })


  }
}
</script>


<style scoped>
/*@import url('../../static/css/common.css');*/
/*@import url('../../static/css/swiper.min.css');*/
/*@import url('../../static/css/inner.css');*/
/*@import url('../../static/css/respond.css');*/


</style>



// WEBPACK FOOTER //
// src/views/join_us.vue